import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { filter, finalize, map, Observable, of, tap, throwError } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { PagesService } from 'src/app/pages/services/pages.service';
import { addEventFormFeild } from '../forms/create-event';
import { HubbleService } from '../service/hubble.service';
import { format } from 'date-fns';
import { cancelEventFormField } from '../forms/cancel-event';
import { editEventFormField } from '../forms/edit-event';
import { addRecordingEventFormField } from '../forms/add-recording';
import CustomStore from 'devextreme/data/custom_store';
import Query from 'devextreme/data/query';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services';
import { JobfairService } from '../../jobfair/service/jobfair.service';

@Component({
	selector: 'app-events',
	templateUrl: './events.page.html',
	styleUrls: ['./events.page.scss'],
})
export class EventsPage implements OnInit {
	currentPagePermission = 'hubble_events';
	isCanOpenBox = true;
	communityList = [];
	showLoader = false;

	allEvents: any;

	pageSize = 20;
	searchValue = '';
	pageNum: number = 1;
	pageInfo: any = {
		pageNum: this.pageNum,
		pageSize: this.pageSize,
	};
	assignData: any = {
		pageNum: this.pageNum,
		pageSize: this.pageSize,
		itemId: 'post_id',
	};

	eventTimeFrame = 'upcoming';

	tagOnTheEvent = [
		{ id: 'Jobs in Climate', name: 'Jobs in Climate' },
		{
			id: 'Sustainability in the Built Environment',
			name: 'Sustainability in the Built Environment',
		},
		{ id: 'Entrepreneurship', name: 'Entrepreneurship' },
	];

	defaultTimeZoneList: any;
	timeZoneList: any;

	eventTypes = [];

	allCommunities$: Observable<any> = this.hubbleService
		.fetchAllCommunity()
		.pipe(
			filter(({ data }: any) => {
				return data.length > 0;
			}),
			map((communities: any) =>
				communities.data.map((c: any) => {
					return { name: c.name, id: c.id };
				}),
			),
			tap((data: any) => {
				this.communityList = data;
			}),
		);

	eventTags$: Observable<any> = this.hubbleService.loadEventTags().pipe(
		filter(({ data }: any) => {
			return data.length > 0;
		}),
		tap((data: any) => {
			// console.log(data,'fasdf asdfjkhasdf')
			this.tagOnTheEvent =
				data.data?.map((tag: any) => {
					return { name: tag.name, id: tag.name };
				}) ?? [];
		}),
	);

	eventTypes$: Observable<any> = this.hubbleService.fetchEventTypes().pipe(
		filter(({ data }: any) => {
			return data.length > 0;
		}),
		tap((data: any) => {
			this.eventTypes = data?.data;
		}),
	);

	constructor(
		private pagesService: PagesService,
		private hubbleService: HubbleService,
		private popoverController: PopoverController,
		public authService: AuthService,
		private jobFairService: JobfairService,
	) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app',
		);
	}

	ngOnInit() {
		this.jobFairService.getTimeZoneList().subscribe(data => {
			this.timeZoneList = data;
			this.defaultTimeZoneList = data?.data.find((e: any) => {
				return e.name === 'US/Pacific';
			});
			console.log(this.defaultTimeZoneList, 'default timezone list');
		});

		this.hubbleService.initAllCommunity();
		this.hubbleService.loadAllCommunity().subscribe();
		this.allCommunities$.subscribe();

		this.hubbleService.initEventTag();
		this.hubbleService.initEventTagApi().subscribe();
		this.eventTags$.subscribe();

		this.hubbleService.initEventType();
		this.hubbleService.initEventTypeApi().subscribe();
		this.eventTypes$.subscribe();

		this.getEventsWithPagination();
	}

	onPageChanged(event: any) {
		console.log(event, 'on page change');
		const pageEventName = event.fullName;
		if (pageEventName == 'paging.pageIndex') {
			this.pageNum = event.value + 1;
		}
		if (pageEventName == 'paging.pageSize') {
			this.pageSize = event.value;
		}
		if (pageEventName == 'searchPanel.text') {
			this.searchValue = event.value;
		}
	}

	async getEventsWithPagination() {
		console.log('GETTING EVENTS CALL');
		this.allEvents = new CustomStore({
			key: 'postId',
			load: async (loadOptions: any) => {
				console.log(loadOptions);
				this.showLoader = true;
				// if (!!loadOptions.take) {
				// 	if ([10, 20, 50, 100, 500].indexOf(loadOptions.take) == -1) {
				// 		loadOptions.take = this.pageInfo['pageSize'];
				// 	} else {
				// 		this.assignData['pageSize'] = loadOptions.take;
				// 	}
				// }
				let response = await this.hubbleService.fetchAllEvents(
					this.pageNum,
					this.pageSize,
					this.eventTimeFrame,
					this.searchValue,
				);
				const finalResponse: any = await response.json();
				console.log(finalResponse, 'finalResponse');

				let evArr = finalResponse.data.map((e: any) => {
					return {
						userId: e.author_id,
						communityNames: e.community_names,
						postDescription: e.post_description,
						eventTitle: e.invite.title,
						eventDate: e.invite.startTime,
						eventEndDate: e.invite.endTime,
						isLFA: e.invite.is_LFA,
						rsvpUrl: e.invite.rsvpUrl,
						id: e.id,
						postId: e.post_id,
						zoom: e.invite.place.url,
						email: e.author_email,
						status: e.cancel_event ?? false,
						recordingUrl: e.invite.recording_url,
						speakerEmail: e.speakerEmail,
						moderatorEmail: e.moderatorEmail,
						tagOnTheEvent: e.tagOnTheEvent,
						eventImage: e.eventImage,
						location: e.invite.place.location,
						eventCategory: e.invite.eventCategory,
						eventCategoryName: e.invite.eventCategoryDetails.name,
						price: e.invite.price,
						timeZone: e.timeZone ? e.timeZone : '',
					};
				});

				const totalCount = finalResponse.total_count ?? 0;

				console.log(evArr, finalResponse.total_count);
				this.showLoader = false;

				return {
					data: Query(evArr).toArray(),
					totalCount: totalCount,
					groupCount: totalCount,
				};
			},
		});
	}

	changeEventTimeFrame(event: any) {
		this.eventTimeFrame = event.detail.value;
		this.pageNum = 1;
		this.pageSize = 20;
		this.getEventsWithPagination();
	}

	async addEvent() {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;

			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Add New Event',
					form: addEventFormFeild,
					multiValueSelect: {
						communities: true,
						eventCategory: false,
						tagOnTheEvent: true,
					},
					selectOptions: {
						communities: this.communityList,
						eventCategory: this.eventTypes,
						tagOnTheEvent: this.tagOnTheEvent,
						timeZone: this.timeZoneList?.data,
					},
					// values: {
					// 	timeZone: this.defaultTimeZoneList.id,
					// },
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	onCreate(ref: any, editForm: any) {
		const hours = new Date(editForm.date).getUTCHours();
		const mins = new Date(editForm.date).getUTCMinutes();

		if (
			(!editForm.location && !editForm.zoom) ||
			(editForm.location && editForm.zoom)
		) {
			ref.authService.addToastMsg('Enter either Zoom link or Location');
			return throwError(() => {
				return new Error('Either Location or Zoom Link is a required field');
			});
		}

		console.log('on create is called', ref.timeZoneList);
		const selectedTimezone = ref.timeZoneList.data.find(
			(tz: any) => tz.id === editForm.timeZone,
		);
		console.log(selectedTimezone, 'selected time zone');

		const newEvent = {
			user_id: '',
			posted_group: editForm.communities?.map((c: any) => {
				return { community_id: c };
			}),
			post_description: editForm.postDescription,
			invite: {
				title: editForm.title,
				date: new Date(editForm.date).toISOString(),
				time: new Date(editForm.date)
					.toLocaleTimeString([], {
						hour: '2-digit',
						minute: '2-digit',
						hour12: true,
						timeZone: 'UTC',
					})
					.toUpperCase(),
				is_LFA: editForm.isLFA ?? false,
				invite_type: 1, //Always one
				place: {
					url: editForm.zoom,
					location: editForm.location,
				},
				price: editForm.price,
				rsvpUrl: editForm.rsvp,
				eventCategory: editForm.eventCategory,
			},
			tagOnTheEvent: editForm.tagOnTheEvent?.map((c: any) => {
				return c;
			}),
			eventImage: editForm.eventImage,
			speakerEmail: editForm.speakerEmail,
			moderatorEmail: editForm.moderatorEmail,
			timeZone: selectedTimezone.name,
		};
		console.log(newEvent, editForm.email, 'New Event');
		// return of([]);

		return ref.hubbleService.addEvent(newEvent, editForm.email).pipe(
			tap(() => {
				ref.getEventsWithPagination();
			}),
		);
	}

	async editEvent(event: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;
			console.log(event, 'event');

			let selectedTimezone = this.defaultTimeZoneList;

			if (event.timeZone) {
				selectedTimezone = this.timeZoneList.data.find(
					(tz: any) => tz.name === event.timeZone,
				);
				console.log(selectedTimezone, 'selected time zone');
			}

			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Edit Event',
					form: editEventFormField,
					multiValueSelect: {
						tagOnTheEvent: true,
					},
					selectOptions: {
						tagOnTheEvent: this.tagOnTheEvent,
						eventCategory: this.eventTypes,
						timeZone: this.timeZoneList?.data,
					},
					values: {
						email: event.email,
						postId: event.postId,
						date: event.eventDate,
						isLFA: event.isLFA,
						rsvp: event.rsvpUrl,
						zoom: event.zoom,
						eventLink: environment.url.joinHubbleEvent + event.id,
						postDescription: event.postDescription,
						title: event.eventTitle,
						moderatorEmail: event.moderatorEmail,
						speakerEmail: event.speakerEmail,
						tagOnTheEvent: event.tagOnTheEvent,
						eventImage: event.eventImage,
						location: event.location,
						eventCategory: event.eventCategory,
						price: event.price,
						timeZone: selectedTimezone.id,
					},
					onSubmitForm: this.onEdit,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	onEdit(ref: any, editForm: any) {
		// const dateUTC = ref.convertToUtcTimestamp(editForm.date);
		console.log('on create is called', ref.timeZoneList);
		const selectedTimezone = ref.timeZoneList.data.find(
			(tz: any) => tz.id === editForm.timeZone,
		);
		console.log(selectedTimezone, 'selected time zone');

		if (
			(!editForm.location && !editForm.zoom) ||
			(editForm.location && editForm.zoom)
		) {
			ref.authService.addToastMsg('Enter either Zoom link or Location');
			return throwError(() => {
				return new Error('Either Location or Zoom Link is a required field');
			});
		}

		const editEvent = {
			post_id: editForm.postId,
			discuss_title: editForm.title,
			date: new Date(editForm.date).toISOString(),
			time: new Date(editForm.date)
				.toLocaleTimeString([], {
					hour: '2-digit',
					minute: '2-digit',
					hour12: true,
					timeZone: 'UTC',
				})
				.toUpperCase(),
			meeting_link: editForm.zoom,
			post_description: editForm.postDescription,
			user_id: '',
			rsvpUrl: editForm.rsvp,
			is_LFA: editForm.isLFA,
			speakerEmail: editForm.speakerEmail,
			moderatorEmail: editForm.moderatorEmail,
			eventImage: editForm.eventImage,
			tagOnTheEvent: editForm.tagOnTheEvent,
			location: editForm.location,
			price: editForm.price,
			eventCategory: editForm.eventCategory,
			timeZone: selectedTimezone.name,
		};

		return ref.hubbleService.editEvent(editEvent, editForm.email).pipe(
			tap(() => {
				ref.getEventsWithPagination();
			}),
		);
	}

	async cancelEvent(event: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;

			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Cancel Event',
					form: cancelEventFormField,
					onSubmitForm: this.onCancel,
					values: {
						postId: event.postId,
						userId: event.userId,
					},
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}
	onCancel(ref: any, editForm: any) {
		const eventToCancel = {
			post_id: editForm.postId,
			cancel_event_reason: editForm.cancelEventReason,
			user_id: editForm.userId,
		};
		return ref.hubbleService.cancelEvent(eventToCancel).pipe(
			tap(() => {
				ref.getEventsWithPagination();
			}),
		);
	}

	onDelete(editForm: any, ref: any = this) {
		const eventToDelete = {
			post_id: editForm.postId,
			user_id: editForm.userId,
		};
		return ref.hubbleService
			.deleteEvent(eventToDelete)
			.pipe(
				tap(() => {
					ref.getEventsWithPagination();
				}),
			)
			.subscribe();
	}

	async addRecording(event: any) {
		if (this.isCanOpenBox) {
			this.isCanOpenBox = false;

			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Add Recording',
					form: addRecordingEventFormField,
					onSubmitForm: this.onAddRecording,
					values: {
						postId: event.postId,
						userId: event.userId,
					},
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;`;

			await modal.present();

			await modal.onDidDismiss();

			this.isCanOpenBox = true;
		}
	}

	onAddRecording(ref: any, editForm: any) {
		const event = {
			post_id: editForm.postId,
			recording_url: editForm.recordingUrl,
			user_id: editForm.userId,
		};
		return ref.hubbleService.addEventRecording(event).pipe(
			tap(() => {
				ref.getEventsWithPagination();
			}),
		);
	}

	checkLive(startTime: any, endTime: any): boolean {
		const currentTime = new Date().getTime();
		return currentTime < endTime && currentTime >= startTime ? true : false;
	}

	convertToUtcTimestamp(timestamp: Date) {
		var date = new Date(timestamp);
		var utcTimestamp = date.getTime() + date.getTimezoneOffset() * 60000;
		return utcTimestamp;
	}

	deploy() {
		this.hubbleService.deploy().subscribe(data => {
			this.authService.addToastMsg(
				'Deployment started please wait for 10-15 mins.',
			);
		});
	}
}
